<div class="labelWithIcon">
  <i *ngIf="data.iconCssClass" [attr.class]="data.iconCssClass" aria-hidden="true"></i>
  <span>{{ data.text | translate }}</span>
  <span *ngIf="data.additionalText">{{ data.additionalText | translate }}</span>
</div>
